import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=35d1a9ec&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=35d1a9ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1a9ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuSpacer: require('/codebuild/output/src260376273/src/onvocado-landing/components/global/MenuSpacer.vue').default,PageContentSections: require('/codebuild/output/src260376273/src/onvocado-landing/components/PageContentSections.vue').default,PageNotFound: require('/codebuild/output/src260376273/src/onvocado-landing/components/global/PageNotFound.vue').default,Footer: require('/codebuild/output/src260376273/src/onvocado-landing/components/global/Footer.vue').default,SEO: require('/codebuild/output/src260376273/src/onvocado-landing/components/global/SEO.vue').default,PreviewModeWrapper: require('/codebuild/output/src260376273/src/onvocado-landing/components/global/PreviewModeWrapper.vue').default})
